// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__13rpR","label":"Completed_label__335hD"};